const DISPLAY_PREVIEW_ORDER = {
  // horizontal orientation, horizontal arrangement
  horizontal_horizontal: {
    x2: ['HDMI 1', 'HDMI 2'],
    x3: ['HDMI 1', 'HDMI 2', 'HDMI 3'],
    x4: ['HDMI 1', 'HDMI 2', 'HDMI 3', 'HDMI 4']
  },
  // horizontal orientation, horizontal arrangement
  horizontal_vertical: {
    x2: ['HDMI 1', 'HDMI 2'],
    x3: ['HDMI 1', 'HDMI 2', 'HDMI 3'],
    x4: ['HDMI 1', 'HDMI 2', 'HDMI 3', 'HDMI 4']
  },
  // horizontal orientation, 2x2 arrangement
  horizontal_2x2: {
    x4: ['HDMI 1', 'HDMI 2', 'HDMI 3', 'HDMI 4']
  },
  // rotateLeft orientation, horizontal arrangement
  rotateLeft_horizontal: {
    x2: ['HDMI 1', 'HDMI 2'],
    x3: ['HDMI 1', 'HDMI 2', 'HDMI 3'],
    x4: ['HDMI 1', 'HDMI 2', 'HDMI 3', 'HDMI 4']
  },
  // rotateLeft orientation, vertical arrangement
  rotateLeft_vertical: {
    x2: ['HDMI 2', 'HDMI 1'],
    x3: ['HDMI 3', 'HDMI 2', 'HDMI 1'],
    x4: ['HDMI 4', 'HDMI 3', 'HDMI 2', 'HDMI 1']
  },
  // rotateLeft orientation, 2x2 arrangement
  rotateLeft_2x2: {
    x4: ['HDMI 2', 'HDMI 4', 'HDMI 1', 'HDMI 3']
  },
  // rotateLeft orientation, horizontal arrangement
  rotateRight_horizontal: {
    x2: ['HDMI 2', 'HDMI 1'],
    x3: ['HDMI 3', 'HDMI 2', 'HDMI 1'],
    x4: ['HDMI 4', 'HDMI 3', 'HDMI 2', 'HDMI 1']
  },
  // rotateLeft orientation, vertical arrangement
  rotateRight_vertical: {
    x2: ['HDMI 1', 'HDMI 2'],
    x3: ['HDMI 1', 'HDMI 2', 'HDMI 3'],
    x4: ['HDMI 1', 'HDMI 2', 'HDMI 3', 'HDMI 4']
  },
  // rotateLeft orientation, 2x2 arrangement
  rotateRight_2x2: {
    x4: ['HDMI 3', 'HDMI 1', 'HDMI 4', 'HDMI 2']
  }
}

export const assignDisplayPreviews = (list, displayOrientation, arrangement) => {
  const outputCount = list.length
  const previews = DISPLAY_PREVIEW_ORDER[`${displayOrientation}_${arrangement}`][`x${outputCount}`]

  return list.map((item, index) => {
    return {
      ...item,
      label: previews[index]
    }
  })
}
